import { ThermostatType } from "../../../store/LegacyStore/models";
import { Simulators } from "../../../store/WorkspaceStore/models";
import { withNuheat } from "./nuheat";

type InjectedProps = ThermostatType;

export const withRedux = <BaseProps extends InjectedProps>(
  BaseComponent: React.ComponentType<BaseProps>,
  simulator: Simulators
) => {
  switch (simulator) {
    case Simulators.NuHeat:
      return withNuheat(BaseComponent);
    default:
      return BaseComponent;
  }
};
